<template>
  <svg class="Ldr" viewBox="0 0 50 50" :width="`${props.size}px`" :height="`${props.size}px`">
    <circle :stroke="props.color" cx="25" cy="25" r="20" fill="none" :stroke-width="`${props.weight}px`" />
  </svg>
</template>

<script setup>
  import { Props } from './props.js';
  //--------------------------
  const props = defineProps(Props());
</script>

<style scoped lang="scss">
  @import './styles.scss';
</style>